export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-movie-line' },
  { id: 'movie', name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { id: 'tv', name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { id: 'anime', name: '动漫', slug: 'anime', icon: 'ri-emotion-line' },
  { id: 'variety', name: '综艺', slug: 'variety', icon: 'ri-mic-line' },
  { id: 'documentary', name: '纪录片', slug: 'documentary', icon: 'ri-earth-line' },
];

export interface Movie {
  id: string;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  tags: string[];
  updateEpisode: string;
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
}

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'movie',
    year: 2026,
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20spaceship%20and%20earth%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20clean%20minimal%20background%2C%20film%20poster%20style%20with%20Chinese%20text%20placeholder&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    tags: ['科幻', '灾难', '冒险'],
    updateEpisode: 'HD高清',
    isHot: true,
    isNew: true,
    isVip: false,
  },
  {
    id: 'movie-2',
    title: '长安三万里2',
    category: 'movie',
    year: 2026,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20with%20ancient%20Tang%20dynasty%20cityscape%2C%20traditional%20Chinese%20art%20style%2C%20warm%20golden%20tones%2C%20poetic%20atmosphere%2C%20clean%20composition%2C%20film%20poster%20design&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    description: '安史之乱后，长安陷入危机。高适与李白再度联手，以诗为剑，以酒为马，谱写了一段荡气回肠的英雄史诗。',
    tags: ['动画', '历史', '剧情'],
    updateEpisode: 'HD高清',
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 'movie-3',
    title: '封神第二部',
    category: 'movie',
    year: 2025,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20dramatic%20red%20and%20gold%20lighting%2C%20cinematic%20poster%20style%2C%20clean%20dark%20background&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    description: '殷商末年，纣王无道。姜子牙携封神榜下山，辅佐武王伐纣。一场人、仙、妖三界大战就此拉开帷幕。',
    tags: ['奇幻', '动作', '史诗'],
    updateEpisode: 'HD高清',
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 'movie-4',
    title: '热辣滚烫2',
    category: 'movie',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20warm%20lighting%2C%20modern%20urban%20setting%2C%20inspirational%20theme%2C%20bright%20and%20energetic%20colors%2C%20film%20poster%20design%2C%20clean%20composition&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    description: '乐莹在新的人生阶段遇到了新的挑战和机遇，她用自己的方式证明：每一次跌倒都是为了更好地站起来。',
    tags: ['喜剧', '剧情', '励志'],
    updateEpisode: 'HD高清',
    isHot: false,
    isNew: true,
    isVip: false,
  },
  {
    id: 'movie-5',
    title: '哪吒之魔童闹海',
    category: 'anime',
    year: 2025,
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20with%20mythological%20character%20design%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20dynamic%20action%20pose%2C%20anime%20style%2C%20clean%20background%2C%20cinematic%20lighting&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    description: '哪吒与敖丙在天劫之后灵魂尚存，太乙真人欲用七色宝莲为二人重塑肉身，却遭遇重重困难。哪吒的冒险故事仍在继续。',
    tags: ['动画', '奇幻', '冒险'],
    updateEpisode: 'HD高清',
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 'movie-6',
    title: '飞驰人生3',
    category: 'movie',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20racing%20car%20on%20track%2C%20dramatic%20sunset%20lighting%2C%20action%20cinematic%20style%2C%20warm%20golden%20tones%2C%20clean%20composition%2C%20film%20poster%20design&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    description: '张驰重返赛场，带着新老队友一起挑战更高级别的拉力赛。这一次，他们不仅要赢，更要证明自己的价值。',
    tags: ['喜剧', '运动', '剧情'],
    updateEpisode: 'HD高清',
    isHot: false,
    isNew: true,
    isVip: false,
  },
  {
    id: 'tv-1',
    title: '庆余年第二季',
    category: 'tv',
    year: 2025,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20ancient%20palace%20setting%2C%20mysterious%20atmosphere%2C%20warm%20candlelight%20tones%2C%20royal%20costume%20design%2C%20clean%20dark%20background%2C%20drama%20poster%20style&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    description: '范闲在经历了一系列风波后，逐渐揭开了隐藏在庆国朝堂之下的惊天秘密。权力、亲情、爱情交织，步步惊心。',
    tags: ['古装', '权谋', '剧情'],
    updateEpisode: '更新至36集',
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 'tv-2',
    title: '繁花',
    category: 'tv',
    year: 2024,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20nostalgic%20warm%20lighting%2C%20retro%20fashion%20style%2C%20cityscape%20background%2C%20elegant%20composition%2C%20drama%20poster%20design&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    description: '九十年代的上海，遍地是机遇。阿宝凭借自己的智慧与勇气，在商海中沉浮，书写了一段传奇人生。',
    tags: ['年代', '商战', '剧情'],
    updateEpisode: '全30集',
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 'tv-3',
    title: '大奉打更人',
    category: 'tv',
    year: 2025,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20detective%20TV%20series%20poster%20with%20ancient%20Chinese%20setting%2C%20mysterious%20atmosphere%2C%20martial%20arts%20elements%2C%20dramatic%20lighting%2C%20clean%20dark%20background%2C%20drama%20poster&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    description: '现代警校毕业生许七安穿越到大奉王朝，凭借现代刑侦知识与超凡武学天赋，在这片奇幻大陆上破案缉凶。',
    tags: ['奇幻', '悬疑', '古装'],
    updateEpisode: '更新至24集',
    isHot: false,
    isNew: true,
    isVip: false,
  },
  {
    id: 'tv-4',
    title: '狂飙',
    category: 'tv',
    year: 2023,
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20series%20poster%20with%20police%20and%20gangster%20theme%2C%20tense%20atmosphere%2C%20dark%20urban%20setting%2C%20dramatic%20contrast%20lighting%2C%20clean%20composition%2C%20drama%20poster&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    description: '京海市一线刑警安欣在与黑恶势力的斗争中，历经二十余年，从青涩到成熟，始终坚守正义与信念。',
    tags: ['犯罪', '悬疑', '剧情'],
    updateEpisode: '全39集',
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 'anime-1',
    title: '斗破苍穹年番',
    category: 'anime',
    year: 2025,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20series%20poster%20with%20martial%20arts%20fantasy%20theme%2C%20young%20warrior%20character%2C%20flame%20and%20energy%20effects%2C%20dynamic%20composition%2C%20vibrant%20colors%2C%20anime%20style%2C%20clean%20background&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    description: '萧炎在迦南学院中不断突破自我，炼制高阶丹药，收服异火，向着大陆巅峰强者之路迈进。',
    tags: ['奇幻', '热血', '战斗'],
    updateEpisode: '更新至88集',
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 'anime-2',
    title: '凡人修仙传动漫',
    category: 'anime',
    year: 2025,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20cultivation%20fantasy%20poster%20with%20immortal%20cultivator%20character%2C%20floating%20mountains%20and%20clouds%2C%20ethereal%20atmosphere%2C%20mystical%20lighting%2C%20elegant%20composition%2C%20anime%20style&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    description: '一个普通山村少年韩立，凭借自身努力和合理算计，在残酷的修仙世界中一步步踏上巅峰。',
    tags: ['修仙', '冒险', '战斗'],
    updateEpisode: '更新至72集',
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 'variety-1',
    title: '奔跑吧第12季',
    category: 'variety',
    year: 2025,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20and%20energetic%20colors%2C%20outdoor%20setting%2C%20fun%20atmosphere%2C%20clean%20composition%2C%20TV%20show%20poster&width=400&height=560&seq=movie-poster-13&orientation=portrait',
    description: '常驻嘉宾与新加入的飞行嘉宾一起，在各地展开趣味横生的挑战任务，带来无限欢乐。',
    tags: ['真人秀', '搞笑', '竞技'],
    updateEpisode: '更新至10期',
    isHot: false,
    isNew: true,
    isVip: false,
  },
  {
    id: 'doc-1',
    title: '舌尖上的中国4',
    category: 'documentary',
    year: 2025,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20Chinese%20cuisine%20close-up%2C%20steaming%20hot%20dishes%2C%20warm%20kitchen%20lighting%2C%20traditional%20cooking%20scene%2C%20rich%20colors%2C%20documentary%20style&width=400&height=560&seq=movie-poster-14&orientation=portrait',
    description: '深入中国各地，探寻那些即将消失的传统美食与手艺人故事，用镜头记录最真实的中国味道。',
    tags: ['美食', '人文', '纪实'],
    updateEpisode: '全8集',
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 'tv-5',
    title: '三体',
    category: 'tv',
    year: 2024,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20and%20alien%20civilization%20theme%2C%20mysterious%20dark%20space%20background%2C%20three%20suns%20effect%2C%20cinematic%20lighting%2C%20clean%20composition%2C%20drama%20poster&width=400&height=560&seq=movie-poster-15&orientation=portrait',
    description: '纳米科学家汪淼在警官史强的邀请下，进入神秘的网络游戏《三体》，揭开了一个外星文明即将入侵地球的真相。',
    tags: ['科幻', '悬疑', '剧情'],
    updateEpisode: '全30集',
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 'movie-7',
    title: '第二十条',
    category: 'movie',
    year: 2024,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20with%20courtroom%20setting%2C%20serious%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20lawyer%20theme%2C%20clean%20composition%2C%20film%20poster%20design&width=400&height=560&seq=movie-poster-16&orientation=portrait',
    description: '人到中年的检察官韩明，在职业生涯的关键时刻卷入了一桩分歧巨大的案件，他必须在法律与人情之间做出选择。',
    tags: ['剧情', '法律', '现实'],
    updateEpisode: 'HD高清',
    isHot: false,
    isNew: false,
    isVip: false,
  },
];